import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import DocumentMeta from 'react-document-meta';
import BannerCard from './BannerCard';
import  Slider  from 'react-slick';



export default class HomeBannerSlider extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidUpdate() {
    if (this.refs.slider) {
      this.refs.slider.innerSlider.autoPlay();
    }
  }

  render() {
    let auth = this.props.auth;
    let browser = this.props.browser;

    let settings = {};

    if (browser.greaterThan.desktop) {
      settings = {
        autoplay: false,
        autoplaySpeed: 5000,
        infinite: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 1000,
        fade: true
      };
    } else {
      settings = {
        autoplay: false,
        autoplaySpeed: 5000,
        infinite: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 1000
      };
    }



    let homeBanners = '';
    homeBanners = [
      {
        title: 'Global Resource Directory',
        tag: 'The place to find organizations and services exclusively for women around the world.',
        imgUrl: 'directory4.jpg',
        btnText: 'Sign up',
        btnUrl: '',
        learnMoreText: 'Find resources',
        learnMoreUrl: '/global-resource-directory',
        slug: 'directory',
        isExternalUrl: false
      }
    ];

    let homeBannerList = homeBanners.map((banner, index) => {
      return <div data-slideindex={`slide-${index}`} key={`slide-${index}`}>
        <BannerCard

          title = {banner.title}
          tag = {banner.tag}
          imgUrl = {banner.imgUrl}
          btnText = {banner.btnText}
          btnUrl = {banner.btnUrl}
          learnMoreUrl = {banner.learnMoreUrl}
          learnMoreText = {banner.learnMoreText}
          slug = {banner.slug}
          isExternalUrl = {banner.isExternalUrl}
          openSignupFormRequest={this.props.openSignupFormRequest}
        />
      </div>
    });




    return(
      <main>
        <div  className="homeBannerFeaturedOrgs-wrapper">

          <Slider ref="slider" { ...settings }>{homeBannerList}</Slider>
        </div>
      </main>
    )
  }
};



// WEBPACK FOOTER //
// ./src/components/homeBanner2/HomeBannerSlider.jsx